export const parseEventName = (
  canonical: string,
): { area: string | null; resource: string; action: string } => {
  const parts = canonical.split('.');
  if (parts.length === 2) return { area: null, resource: parts[0], action: parts[1] };
  if (parts.length === 3) return { area: parts[0], resource: parts[1], action: parts[2] };
  throw new Error(`Invalid event name: "${canonical}" (expected 2 or 3 segments)`);
};
